
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA à La Seyne-sur-Mer dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à La Seyne-sur-Mer certifiée Google Partner, aide les entreprises seynoises à développer leur visibilité en ligne et attirer plus de clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads à La Seyne-sur-Mer dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à La Seyne-sur-Mer certifiée Google Partner, aide les entreprises seynoises à développer leur visibilité en ligne et attirer plus de clients.",
        },
      ],
    };
  },
};
